import { render, staticRenderFns } from "./NextTruckLoadSnippet.vue?vue&type=template&id=4ec38fe2"
import script from "./NextTruckLoadSnippet.vue?vue&type=script&lang=js"
export * from "./NextTruckLoadSnippet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports